import React from 'react';
import {
	Button,
	Checkbox,
	Dropdown,
	Grid,
	GridColumn,
	Header,
	Label,
	Pagination,
	Segment,
	Table
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import styles from './styles';
import { observable } from 'mobx';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import SortByField from 'components/SortByField';
import UiShared from 'stores/UiShared';
import ItemRemindersScreen from 'stores/ui/admin/ItemReminders';
import ItemModal from 'components/Reminder/ItemModal';
const SCHEDULE_TYPES = { 1: 'days', 2: 'weeks', 3: 'months' };

@withRouter
@inject(rootStore => ({
	itemRemindersScreen: rootStore.ui.admin.itemReminders,
	uiShared: rootStore.uiShared
}))
@observer
export default class ItemReminderList extends React.Component {
	props: {
		itemRemindersScreen: ItemRemindersScreen,
		uiShared: UiShared
	};

	@observable pageSize: number = 100;
	@observable itemToDisplayId: number = null;
	@observable itemNewIsOpen: boolean = false;

	msgStore: MsgStore = new MsgStore();

	componentDidMount() {
		const { itemRemindersScreen } = this.props;
		try {
			itemRemindersScreen.loadItems();
		} catch (err) {
			this.msgStore.setError(err);
		}
	}

	render() {
		const itemRemindersScreen: ItemRemindersScreen = this.props.itemRemindersScreen;
		const { items } = itemRemindersScreen;
		return (
			<Segment loading={itemRemindersScreen.isLoading}>
				<Header as="h1">Reminders</Header>
				<MessageBox msgStore={this.msgStore} />
				<div className={styles.viewSelectorRow}>
					<div>
						<Button
							icon="add"
							size="small"
							label="Add new reminder"
							primary
							onClick={() => {
								this.itemNewIsOpen = true;
							}}
							className={styles.btnAdd}
						/>
					</div>
					<div>
						<Label size="large" basic className={styles.viewLbl}>
							Records per page:
						</Label>
						<Dropdown
							selection
							placeholder="Records per page"
							value={this.pageSize}
							onChange={(e, data) => {
								this.pageSize = data.value;
								itemRemindersScreen.setPageSize(data.value);
							}}
							compact
							options={[
								{ text: '10', value: 10 },
								{ text: '20', value: 20 },
								{ text: '50', value: 50 },
								{ text: '100', value: 100 }
							]}
						/>
					</div>
				</div>

				<Grid>
					<GridColumn>
						<Table celled>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>
										<SortByField
											label="Product Name"
											field="productName"
											store={itemRemindersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Therapeutic Area"
											field="therapeuticArea"
											store={itemRemindersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField label="Schedule" field="schedule" store={itemRemindersScreen} />
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Item Codes"
											field="itemCodes"
											store={itemRemindersScreen}
											filterType="like"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Disabled</Table.HeaderCell>
									<Table.HeaderCell>Actions</Table.HeaderCell>
								</Table.Row>
							</Table.Header>

							<Table.Body>
								{items.map((el: ItemReminder, idx) => (
									<Table.Row key={idx}>
										<Table.Cell>{el.productName}</Table.Cell>
										<Table.Cell>{el.therapeuticArea}</Table.Cell>
										<Table.Cell>{`${el.schedule} ${SCHEDULE_TYPES[el.scheduleType]}`}</Table.Cell>
										<Table.Cell>{el.itemCodes}</Table.Cell>
										<Table.Cell>
											<Checkbox checked={el.disabled} readOnly />
										</Table.Cell>
										<Table.Cell>
											<Button
												icon="edit"
												size="small"
												label="Edit"
												primary
												onClick={() => {
													this.itemToDisplayId = el.id;
												}}
											/>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>

							<Table.Footer>
								<Table.Row>
									<Table.HeaderCell colSpan="7" textAlign="right">
										{itemRemindersScreen.numberOfPages > 0 && (
											<Pagination
												activePage={itemRemindersScreen.pageIndex + 1}
												totalPages={itemRemindersScreen.numberOfPages}
												onPageChange={(e, { activePage }) =>
													itemRemindersScreen.setPageIndex(activePage - 1)
												}
											/>
										)}
									</Table.HeaderCell>
								</Table.Row>
							</Table.Footer>
						</Table>
					</GridColumn>
				</Grid>
				<ItemModal
					isOpen={!!this.itemNewIsOpen || !!this.itemToDisplayId}
					itemReminderId={this.itemToDisplayId}
					onRequestReload={async () => {
						itemRemindersScreen.reload();
					}}
					onRequestClose={() => {
						this.itemToDisplayId = null;
						this.itemNewIsOpen = false;
					}}
				/>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Reminders/List.js